const DeleteRoundTable = {
  id: 'delete_roundtable',
  title: 'Delete RoundTable',
  description: `You are deleting {{ roundtable_name }}. 
    This cannot be undone and student data will be lost forever.
  `,
};

const DeleteRecap = {
  id: 'delete_recap',
  title: 'Delete Recap',
  description: `You are deleting Recap. This cannot be undone and you 
    loose this information forever.
  `,
};

const RemoveFromSequence = {
  id: 'remove_from_sequence',
  title: 'Remove from Sequence',
  description: `This action will be remove this RoundTable {{ roundtable_name }} from the sequence. 
    It will not delete the RoundTable, but this action cannot be undone.
  `,
};


export { DeleteRecap, DeleteRoundTable, RemoveFromSequence };



// WEBPACK FOOTER //
// ./src/app/components/Dialogs/TypesDeleteConfirm.js